// Document type key for which the collectionStatus based restriction applies.
export const FINAL_BILL_KEY = "finalBill";

// When the selected document type is Final Bill, upload is enabled ONLY when the
// patient's collectionStatus.status is one of these values. For every other status
// the whole upload modal is disabled. For any other document type this rule does not apply.
export const FINAL_BILL_ALLOWED_COLLECTION_STATUSES = [
  "Collection Rejected — Pending at Central Dashboard",
  "Pending at Central Dashboard",
];

// Returns true when the upload form must be disabled because Final Bill is selected
// but the patient's collectionStatus.status is not in the allowed list.
// `collectionStatus` is an object of shape { status, ... }, so we read `.status`.
export const isFinalBillUploadBlocked = (selectedKey, collectionStatus) => {
  if (selectedKey !== FINAL_BILL_KEY) {
    return false;
  }
  return !FINAL_BILL_ALLOWED_COLLECTION_STATUSES.includes(
    collectionStatus?.status
  );
};
